module.exports = __webpack_public_path__ + "img/atu_logo.91301843.png";